export default __webpack_public_path__ + "cc9a1a28bd10163bb7cb2f0379900b43.png";